import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { productCards } from './productCards.model';

@Injectable({
  providedIn: 'root'
})
export class ProductcardsService {


  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {

  }


  getAll(cardNoOrSerial: string, categoryId: number, subCategoryId: number, productId: number,
    status: number, fromDate: string, toDate: string) {
    return this.http.get<productCards[]>(this.global.APIURL +
      "productcards/productcardDetails?cardNoOrSerial=" + cardNoOrSerial + "&categoryId=" + categoryId +
      "&subCategoryId=" + subCategoryId + "&productId=" + productId + "&status=" + status
      + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  cancelCard(id: number, productId: number, status: number) {
    return this.http.put<any>(this.global.APIURL + "productcards/cancel/" + id + "/" + productId + "/" + status, null);
  }

  update(obj: any) {
    return this.http.put<any>(this.global.APIURL + "productcards/update", obj);
  }

  DeleteBulk(ids: any[]) {
    return this.http.put<any>(this.global.APIURL + "productcards/deletebulk", ids);
  }
}
